import React from 'react';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { TextLoading } from '../../../../../../CommonComponents/OPL/Text/Text.loading';

export const NetWorthLoading = () => {
  return (
    <Card p="32">
      <TextLoading width={90} height="h3" mb="8" />

      <Shimmer width={190} height={29} mb="4" />

      <TextLoading width={136} height="h4" />
    </Card>
  );
};
